const TRANSLATION = {
  common: {
    loading: 'กำลังโหลด',
  },
  i18n: {
    English: 'อังกฤษ',
    Spanish: 'สเปน',
    Russian: 'รัสเซีย',
    'Portuguese (Brazil)': 'โปรตุเกส (บราซิล)',
    Indonesian: 'อินโดนีเซีย',
    Czech: 'เช็ก',
    German: 'เยอรมัน',
    French: 'ฝรั่งเศส',
    Italian: 'อิตาลี',
    Dutch: 'ดัตช์',
    Polish: 'โปแลนด์',
    Vietnamese: 'เวียดนาม',
    Turkish: 'ตุรกี',
    Ukrainian: 'ยูเครน',
    Chinese: 'จีนตัวย่อ',
    'Traditional Chinese': 'จีนตัวเต็ม',
    Japanese: 'ญี่ปุ่น',
    Korean: 'เกาหลี',
    Arabic: 'อาหรับ',
    Persian: 'เปอร์เซีย',
    Thai: 'ไทย',
    Hindi: 'ฮินดี',
    Malay: 'มลายู',
    province: {
      Hebei: 'มณฑลเหอเป่ย',
      Shanxi: 'มณฑลซานซี',
      Liaoning: 'มณฑลเหลียวหนิง',
      Jilin: 'มณฑลจี๋หลิน',
      Heilongjiang: 'มณฑลเฮย์หลงเจียง',
      Jiangsu: 'มณฑลเจียงซู',
      Zhejiang: 'มณฑลเจ้อเจียง',
      Anhui: 'มณฑลอันฮุย',
      Fujian: 'มณฑลฝูเจี้ยน',
      Jiangxi: 'มณฑลเจียงซี',
      Shandong: 'มณฑลซานตง',
      Henan: 'มณฑลเหอหนาน',
      Hubei: 'มณฑลหูเป่ย',
      Hunan: 'มณฑลหูหนาน',
      Guangdong: 'มณฑลกวางตุ้ง',
      Hainan: 'มณฑลไห่หนาน',
      Sichuan: 'มณฑลเสฉวน',
      Guizhou: 'มณฑลกุ้ยโจว',
      Yunan: 'มณฑลยูนนาน',
      Shaanxi: 'มณฑลส่านซี',
      Gansu: 'มณฑลกานซู่',
      Qinghai: 'มณฑลชิงไห่',
      Taiwan: 'มณฑลไต้หวัน',
      Guangxi: 'เขตปกครองตนเองกว่างซีจ้วง',
      Neimenggu: 'เขตปกครองตนเองมองโกเลียใน',
      Tibet: 'เขตปกครองตนเองทิเบต',
      Ningxia: 'เขตปกครองตนเองหนิงเซี่ยหุย',
      Xinjiang: 'เขตปกครองตนเองซินเจียงอุยกูร์',
      HongKong: 'เขตปกครองพิเศษฮ่องกง',
      Macau: 'เขตปกครองพิเศษมาเก๊า',
      Beijing: 'เทศบาลกรุงปักกิ่ง',
      Tianjin: 'เทศบาลนครเทียนจิน',
      Shanghai: 'เทศบาลนครเซี่ยงไฮ้',
      Chongqing: 'เทศบาลนครฉงชิ่ง',
    },
  },
  pageHeader: {
    product: 'ผลิตภัณฑ์',
    tvcTest: 'การทดสอบประสบการณ์ TVC',
    tvcEval: 'การประเมินความคิดสร้างสรรค์ TVC',
    contactUs: 'ติดต่อเรา',
    Pricing: 'ราคา',
    Dashboard: 'เริ่มตอนนี้',
    signIn: 'เข้าสู่ระบบ',
    signUp: 'ลงทะเบียน',
    resourceCenter: 'บล็อก',
    all: 'ทั้งหมด',
    news: 'ข่าว',
    insight: 'ความเข้าใจ',
    case: 'กรณี',
  },
  productSwitch: {
    common: {
      comingSoon: 'เร็ว ๆ นี้',
    },
    modal: {
      heroTitle: 'โปรดเลือกการทดสอบที่คุณต้องการใช้งาน',
      heroSubtitle: 'AdEff พร้อมมอบข้อมูลเชิงลึกด้านครีเอทีฟแบบหลายมิติให้คุณทุกเมื่อที่ต้องการ',
      remainingTimes: 'จำนวนครั้งคงเหลือ: {{count}}',
      supportedAssets: 'สื่อที่รองรับ',
      coreMetrics: 'ตัวชี้วัดหลัก',
      cognitiveNeuroscienceIndicators: 'ตัวชี้วัดด้านการรับรู้-ประสาท',
      consumerAttitudeIndicators: 'ตัวชี้วัดทัศนคติผู้บริโภค',
      outputResult: 'ผลลัพธ์เอาต์พุต',
      dataReport: 'รายงานข้อมูล',
      analysisReport: 'รายงานการวิเคราะห์',
      accessBackend: 'เริ่มตอนนี้',
      tabs: {
        tvc: 'การทดสอบครีเอทีฟแนวนอน',
        portrait: 'การทดสอบครีเอทีฟแนวตั้ง',
      },
      cards: {
        tvcQuick: {
          title: 'แนวนอน-ทดสอบด่วน',
          descriptionHighlight:
            'ประเมินครีเอทีฟอย่างรวดเร็วเพื่อขับเคลื่อนการตัดสินใจด้วยข้อมูล',
        },
        tvcBase: {
          title: 'วินิจฉัยครีเอทีฟ-แนวนอน',
          descriptionHighlight:
            'ปรับรายละเอียดครีเอทีฟอย่างละเอียดพร้อมคำแนะนำการแก้ไขที่นำไปใช้ได้จริง',
          value1: 'ครีเอทีฟ TVC/OTV 10–60 วินาที',
          value2: 'ตัวชี้วัดด้านการรับรู้-ประสาท',
        },
        tvcSurvey: {
          title: 'อินไซต์เชิงลึก-แนวนอน',
          descriptionHighlight:
            'วิเคราะห์ครีเอทีฟหลายมิติพร้อมแนวทางการเพิ่มประสิทธิภาพเชิงกลยุทธ์',
          value1: 'ครีเอทีฟ TVC/OTV 10–60 วินาที',
          value2: 'ตัวชี้วัดด้านการรับรู้-ประสาท',
        },
        portraitQuick: {
          title: 'แนวตั้ง-ทดสอบด่วน',
          descriptionHighlight:
            'ประเมินครีเอทีฟอย่างรวดเร็วเพื่อขับเคลื่อนการตัดสินใจด้วยข้อมูล',
        },
        portraitBase: {
          title: 'วินิจฉัยครีเอทีฟ-แนวตั้ง',
          descriptionHighlight:
            'ปรับรายละเอียดครีเอทีฟอย่างละเอียดพร้อมคำแนะนำการแก้ไขที่นำไปใช้ได้จริง',
          value1: 'ครีเอทีฟแนวตั้ง 5–90 วินาที',
          value2: 'ตัวชี้วัดด้านการรับรู้-ประสาท',
        },
        portraitSurvey: {
          title: 'อินไซต์เชิงลึก-แนวตั้ง',
          descriptionHighlight:
            'วิเคราะห์ครีเอทีฟหลายมิติพร้อมแนวทางการเพิ่มประสิทธิภาพเชิงกลยุทธ์',
          value1: 'ครีเอทีฟแนวตั้ง 5–90 วินาที',
          value2: 'ตัวชี้วัดด้านการรับรู้-ประสาท',
        },
      },
    },
    hoverPanel: {
      columns: {
        tvc: {
          bannerTitle: 'ทดสอบครีเอทีฟแนวนอน',
          assetText: 'สำหรับครีเอทีฟ TVC/OTV ความยาว 10-60 วินาที',
        },
        portrait: {
          bannerTitle: 'ทดสอบครีเอทีฟแนวตั้ง',
          assetText: 'สำหรับครีเอทีฟแนวตั้งความยาว 5-90 วินาที',
        },
      },
      items: {
        tvcQuick: {
          description: 'เปรียบเทียบครีเอทีฟอย่างรวดเร็วและตัดสินใจ',
        },
        tvcBase: {
          title: 'วินิจฉัยครีเอทีฟ',
          description: 'เพิ่มประสิทธิภาพแบบวินาทีต่อวินาที เพื่อยกระดับครีเอทีฟ',
        },
        tvcSurvey: {
          title: 'อินไซต์เชิงลึก',
          description: 'วิเคราะห์รอบด้านเพื่อระบุปัญหาได้อย่างแม่นยำ',
        },
        portraitBase: {
          title: 'วินิจฉัยครีเอทีฟ',
          description: 'เพิ่มประสิทธิภาพแบบวินาทีต่อวินาที เพื่อยกระดับครีเอทีฟ',
        },
        portraitQuick: {
          description: 'เปรียบเทียบครีเอทีฟอย่างรวดเร็วและตัดสินใจ',
        },
        portraitSurvey: {
          title: 'อินไซต์เชิงลึก',
          description: 'วิเคราะห์รอบด้านเพื่อระบุปัญหาได้อย่างแม่นยำ',
        },
      },
    },
  },
  cookieAcceptNotification: {
    title: 'เราใช้คุกกี้',
    desc: 'เราใช้คุกกี้ที่จำเป็นเพื่อให้แน่ใจว่าเว็บไซต์ของเราทำงานได้อย่างถูกต้อง ด้วยความยินยอมของคุณ เราจะใช้คุกกี้วิเคราะห์เพื่อปรับปรุงประสบการณ์ผู้ใช้ของคุณ ดูนโยบายคุกกี้ของเราในนโยบายความเป็นส่วนตัวของเรา',
    btn1: 'ปฏิเสธทั้งหมด',
    btn2: 'ยอมรับทั้งหมด',
    cookiePolicy: 'นโยบายคุกกี้',
  },
  landing: {
    banner: {
      text1: 'ขับเคลื่อนโดย AI',
      text2: 'โฆษณา',
      text3: 'การทดสอบ',
      text4: 'แพลตฟอร์มการทดสอบและการปรับแต่งสร้างสรรค์',
      feature1: 'การถอดรหัสเนื้อหา',
      feature2: 'การคาดการณ์การตอบรับ',
      feature3: 'การรวมข้อมูล',
      feature4: 'การสรุปผล',
      btn1: 'ขอเดโม',
      btn2: 'สร้างโปรเจกต์',
    },
    info: {
      title:
        'อิงจากโมเดลภาษาหลายมิติ HMLLM* คาดการณ์ผลกระทบของความคิดสร้างสรรค์ได้อย่างรวดเร็ว เพิ่มผลตอบแทนจากการลงทุนโฆษณา',
      subTitle: '*โมเดลนี้อิงจากการทดสอบทางประสาทการตลาดจำนวนมากและการสร้างหลายหน่วยงาน',
      detail1: 'การทดสอบโฆษณาอย่างรวดเร็ว',
      detail1Desc:
        'AdEff สามารถรับเส้นโค้งความสนใจของกลุ่มเป้าหมาย การเปลี่ยนแปลงอารมณ์ และการมีส่วนร่วมกับเนื้อหาสร้างสรรค์ภายใน 15 นาที และให้รายงานการประเมินและคำแนะนำในการปรับปรุงอย่างละเอียด',
      detail2: 'คัดเลือกความคิดสร้างสรรค์ที่ดีที่สุดอย่างรวดเร็ว',
      detail2Desc:
        'AdEff รองรับการวัดผลหลายความคิดสร้างสรรค์พร้อมกัน ช่วยให้แบรนด์ตัดสินใจได้อย่างรวดเร็ว และให้การวิเคราะห์เปรียบเทียบอย่างละเอียด',
      detail3: 'การผลิตเวอร์ชันที่มีประสิทธิภาพและหลากหลายด้วยการคลิกเพียงครั้งเดียว',
      detail3Desc:
        'AdEff รองรับการผลิตเวอร์ชันที่มีประสิทธิภาพและหลากหลายอย่างรวดเร็วสำหรับหลายสถานการณ์การเผยแพร่',
    },
    advantages: {
      title: 'ข้อดีของ AdEff',
      item1Title: 'ตอบสนองรวดเร็ว',
      item1Desc: 'สามารถรับรายงานได้ภายใน <tmp>15 นาที</tmp>',
      item2Title: 'โมเดล AI ที่ไม่เหมือนใคร',
      item2Desc: 'โมเดล AI <tmp>ที่อิงจากการตอบรับของกลุ่มเป้าหมาย</tmp> ที่ไม่เหมือนใคร',
      item3Title: 'กราฟิกที่มองเห็นได้',
      item3Desc:
        '<tmp>กราฟิกที่มองเห็นได้</tmp> + การตีความ AI อัจฉริยะ รายงานการทดสอบสร้างขึ้นด้วยคลิกเดียว',
      item4Title: 'ฐานข้อมูลขนาดใหญ่',
      item4Desc: '<tmp>50,000+</tmp> ฐานข้อมูลความคิดสร้างสรรค์',
      item5Title: 'ทีมผู้เชี่ยวชาญ',
      item5Desc: '<tmp>ทีมผู้เชี่ยวชาญ</tmp> ให้การสนับสนุนและคำแนะนำ',
    },
    service: {
      title: 'วิธีการบริการของ AdEff',
      desc: 'เลือกวิธีการบริการที่คุณต้องการ',
      topTitle: 'บริการด้วยตนเองออนไลน์',
      topRow1: 'สร้างโปรเจกต์ด้วยตนเองเพื่อทำการทดสอบ',
      topRow2: 'กราฟิกที่มองเห็นได้ + รายงานการตีความ AI',
      topRow3: 'การวิเคราะห์ตัวชี้วัดทางประสาทวิทยาศาสตร์ที่เป็นกลาง (การเคลื่อนไหวของตา + EEG)',
      topRow4: 'การทดสอบโมเดล AI ที่ไม่เหมือนใคร',
      bottomTitle: 'บริการทีมผู้เชี่ยวชาญ',
      bottomRow1: 'โปรเจกต์ที่สร้างโดยผู้เชี่ยวชาญเพื่อทำการทดสอบ',
      bottomRow2:
        'การวิเคราะห์ตัวชี้วัดทางประสาทวิทยาศาสตร์ที่เป็นกลาง (การเคลื่อนไหวของตา + EEG) สามารถเพิ่มตัวชี้วัดเชิงอัตนัยได้',
      bottomRow3: 'กราฟิกที่มองเห็นได้ + รายงานการตีความจากผู้เชี่ยวชาญ',
      bottomRow4: 'การทดสอบโมเดล AI ที่ไม่เหมือนใคร สามารถเพิ่มการทดสอบตัวอย่างจริงได้',
    },
    footer: {
      title:
        'AdEff ได้รับการสนับสนุนจากโมเดลภาษาหลายมิติ HMLLM สร้างความสัมพันธ์ที่ซับซ้อนระหว่างสัญญาณ EEG ขององค์ประกอบภาพและข้อมูลการติดตามดวงตาสำหรับการทดสอบความคิดสร้างสรรค์ของโฆษณาอย่างรวดเร็ว',
      email: 'อีเมล',
      belongDesc: 'ผลิตภัณฑ์ของ <tmp>Mininglamp Technology</tmp>',
    },
    startBtn: 'เริ่มตอนนี้',
  },
  contact: {
    title: 'ติดต่อเรา',
    copy: 'คัดลอก',
    message: { success: 'คัดลอกสำเร็จ' },
  },
  pricing: {
    title: 'ผู้เชี่ยวชาญด้านการทดสอบและเพิ่มประสิทธิภาพการสร้างสรรค์ด้วย AI',
    starter: {
      title: 'เริ่มต้น',
      desc_1: 'เหมาะสำหรับการทดสอบครั้งเดียว พร้อมใช้งานทันทีหลังซื้อ',
      desc_2: 'เหมาะสำหรับการทดสอบขนาดเล็ก พร้อมใช้งานทันทีหลังซื้อ',
      timesDesc: '<strong>{{count}}</strong> ครั้งทดสอบ',
      timesDesc1: '<strong>{{count}}</strong> ครั้งทดสอบ',
      discount: 'ลด 50%',
      originPrice: 'ราคา',
      desc2: 'โมเดลภาษาหลายมิติที่อิงจากการตอบรับของกลุ่มเป้าหมาย',
      desc3: 'ตอบสนองรวดเร็ว สามารถสร้างรายงานได้ภายใน 15 นาที',
      desc4: 'กราฟิกที่มองเห็นได้อย่างหลากหลาย',
      desc5: 'การตีความ AI อัจฉริยะแบบมืออาชีพ',
      desc6: 'ฐานข้อมูลและมาตรฐานระดับโลก',
      cardDesc1: 'ส่วนลดช่วงเวลาจำกัด เพียง {{pricePerTest}}',
      cardDesc2: 'โควต้าการทดสอบไม่มีวันหมดอายุ',
    },
    premium: {
      time: 'ครั้ง',
    },
    unlimited: {
      title: 'ไม่มีขีดจำกัด',
      cardDesc1: 'เริ่มต้นเพียง {{pricePerTest}}',
      cardDesc2: 'โควต้าใช้งานได้ 1 ปี',
      cardDesc3: 'Benchmark เฉพาะที่ปรับแต่งได้',
      planDesc500: 'รับการทดสอบ 500 ครั้งตลอดทั้งปี',
      planDesc1000: 'รับการทดสอบ 1,000 ครั้งตลอดทั้งปี',
    },
    benefits: {
      title: 'ทำไมต้องเลือก AdEff?',
      subtitle: 'เมื่อใช้ AdEff คุณจะได้รับประโยชน์ดังต่อไปนี้:',
      expertSupport: 'ทีมผู้เชี่ยวชาญพร้อมให้คำแนะนำและสนับสนุน',
      moreNeedsTitle: 'มีความต้องการจัดซื้ออื่น ๆ หรือไม่?',
      customPlanPrefix: 'เรารองรับแพ็กเกจแบบยืดหยุ่นและปรับแต่งได้ — ติดต่อเราได้ที่',
      customPlanSuffix: 'เพื่อรับโซลูชันเฉพาะสำหรับคุณ',
    },
    subscribeBtn: 'สมัครสมาชิกตอนนี้',
    contactUs: 'ติดต่อเรา',
  },
  login: {
    loginText: 'เข้าสู่ระบบ',
    signUpText: '<tmp>ลงทะเบียน</tmp>ฟรี',
    text1: 'เข้าร่วมทีมสำเร็จ',
    text1Desc:
      'AdEff สร้างความสัมพันธ์ที่ซับซ้อนระหว่างสัญญาณ EEG ขององค์ประกอบภาพและข้อมูลการติดตามดวงตาสำหรับการทดสอบความคิดสร้างสรรค์ของโฆษณาอย่างรวดเร็ว',
    text2: 'ผู้ใช้ได้เข้าร่วมบริษัทแล้ว',
    text3: 'ลิงก์เชิญทีมหมดอายุแล้ว',
    text4: 'ลิงก์เชิญทีมไม่สามารถใช้ได้อีกต่อไป',
    optionText1: 'มีบัญชีอยู่แล้ว?',
    optionText2: 'ยังไม่มีบัญชี?',
    alertText1: 'โดยการลงทะเบียน ฉันยอมรับ',
    alertText2: 'ฉันยอมรับ',
    termsOfService: 'ข้อกำหนดในการให้บริการ',
    privacy: 'นโยบายความเป็นส่วนตัว',
    privacyTips: 'โปรดตรวจสอบช่องข้อตกลงก่อนลงทะเบียน',
    and: 'และ',
    or: 'หรือ',
    next: 'ถัดไป',
    googleLogin: 'เข้าสู่ระบบด้วย Google',
    googleSignUp: 'ลงทะเบียนด้วย Google',
    loginWithEmail: 'เข้าสู่ระบบด้วยอีเมล',
    signUpWithEmail: 'ลงทะเบียนด้วยอีเมล',
    password: 'รหัสผ่าน',
    emailAddress: 'ที่อยู่อีเมล',
    enterEmail: 'กรอกอีเมลของคุณ',
    enterPassword: 'กรอกรหัสผ่านของคุณ',
    confirmPassword: 'ยืนยันรหัสผ่าน',
    forgotPassword: 'ลืมรหัสผ่าน?',
    inconsistentPassword: 'รหัสผ่านไม่ตรงกัน',
    verificationCode: 'รหัสยืนยัน',
    emptyVerificationCode: 'รหัสยืนยันไม่สามารถว่างเปล่าได้',
    enterVerificationCode: 'กรอกรหัสยืนยัน',
    sendedVerificationCode: 'รหัสยืนยันได้ถูกส่งไปยังอีเมลของคุณ',
    emailOrPasswordNotCorrect: 'อีเมลหรือรหัสผ่านไม่ถูกต้อง',
    message: {
      text1: 'ข้อมูลที่ป้อนไม่ถูกต้อง',
      text2: 'อีเมลถูกลงทะเบียนแล้ว',
      text3: 'รหัสยืนยันไม่ถูกต้อง!',
      text4: 'บัญชีนี้ไม่ได้เชื่อมโยงกับบริษัท กรุณาเชื่อมโยงใหม่!',
      text5: 'กรุณากรอกอีเมลในรูปแบบที่ถูกต้อง',
      text6: 'รหัสผ่านต้องมีอย่างน้อย 12 ตัวอักษร',
      text7: 'รหัสผ่านต้องมีตัวอักษรพิมพ์ใหญ่ พิมพ์เล็ก และตัวเลข',
      requestLimit: 'ของคุณมีการขอสมาชิกมากเกินไป กรุณาลองใหม่อีกครั้งในภายหลัง',
    },
  },
  resetPwdPage: {
    submit: 'ส่ง',
    emailNotFound: 'กรุณาตรวจสอบอีเมลของคุณ',
    emailHasSent: 'อีเมลได้ถูกส่งไปยัง {{email}}',
    checkYourInbox: 'ตรวจสอบอีเมลของคุณ',
    resetYourPassword: 'รีเฟรชรหัสผ่าน',
    resetLinkHasSent: 'ลิงก์รีเฟรชรหัสผ่านได้ถูกส่งไปยังอีเมลที่สมัครสมาชิกของคุณ',
    enterYourEmailAddress: 'กรอกอีเมลของคุณ',
    didNotGetEmail: 'ไม่ได้รับอีเมล?',
    tryAgain: 'ลองใหม่อีกครั้ง',
    goBackToSign: 'กลับไปที่ล็อกอิน',
    email: 'อีเมล',
    enterYourEmail: 'กรอกอีเมลของคุณ',
    resetPassword: 'รีเฟรชรหัสผ่าน',
    resetPwdSuccess: 'รหัสผ่านถูกรีเฟรชสำเร็จ',
    message: {
      resetLinkCodeError: 'ลิงก์รีเฟรชรหัสผ่านไม่ถูกต้อง',
      requestLimit: 'ของคุณมีการขอสมาชิกมากเกินไป กรุณาลองใหม่อีกครั้งในภายหลัง',
    },
  },
  memberRequestPage: {
    title: 'ตรวจสอบคำขอสมาชิก',
    subTitle: 'คำขอมาจาก:',
    deny: 'ปฏิเสธ',
    approve: 'อนุมัติ',
    teamFull: 'ทีมเต็ม',
    yourTeamIsFull:
      'ทีมของคุณเต็มแล้ว คุณสามารถติดต่อเราเพื่อขอสมาชิกเพิ่มเติมหรือเอาสมาชิกคนอื่นออก',
    manageMembers: 'จัดการสมาชิกใน AdEff',
    requestApproved: 'อนุมัติคำขอแล้ว',
    approvedDesc:
      'คุณได้อนุมัติ <tmp>{{name}}</tmp> ให้เข้าร่วมทีมของคุณแล้ว และได้ส่งอีเมลแจ้งเตือนโดยอัตโนมัติ',
    requestDeclined: 'ปฏิเสธคำขอแล้ว',
    declinedDesc:
      'คุณได้ปฏิเสธ <tmp>{{name}}</tmp> ให้เข้าร่วมทีมของคุณแล้ว และได้ส่งอีเมลแจ้งเตือนโดยอัตโนมัติ',
  },
  infoBindPage: {
    title: 'การทดสอบโฆษณาที่ขับเคลื่อนด้วย AI',
    desc: 'อิงจากโมเดลภาษาหลายมิติ HMLLM* คาดการณ์ผลกระทบของความคิดสร้างสรรค์ได้อย่างรวดเร็ว เพิ่มผลตอบแทนจากการลงทุนโฆษณา',
    joinAdEff: 'เข้าร่วม AdEff และเริ่มต้นการเดินทางใหม่',
    advantages: {
      title1: 'ทรงพลังมากขึ้น',
      desc1: 'โมเดล AI ที่ไม่เหมือนใครที่อิงจากฐานข้อมูลขนาดใหญ่',
      title2: 'ประหยัดมากขึ้น',
      desc2: 'เพียง 10% ของราคาแบบดั้งเดิม',
      title3: 'รวดเร็วมากขึ้น',
      desc3: 'สามารถรับรายงานได้ภายใน 15 นาที',
      title4: 'มืออาชีพมากขึ้น',
      desc4: 'เพลิดเพลินกับการสนับสนุนบริการ 24/7 และบริการจากทีมผู้เชี่ยวชาญ',
    },
    username: 'ชื่อผู้ใช้',
    company: 'บริษัท',
    placeOfResidence: 'ประเทศ/ภูมิภาค',
    invitationCode: 'รหัสอ้างอิง',
    createAccountForFree: 'สร้างบัญชีฟรี',
    refreshStatus: 'รีเฟรชสถานะ',
    reapply: 'สมัครใหม่',
    bySigningUp: 'การลงทะเบียนหมายถึงการยอมรับ',
    termsOfService: 'ข้อกำหนดในการให้บริการ',
    and: 'และ',
    privacyPolicy: 'นโยบายความเป็นส่วนตัว',
    message: {
      success: 'คำขอสร้างบัญชีได้ถูกส่งแล้ว กรุณารอสักครู่!',
      success2: 'สร้างบัญชีสำเร็จ',
      error: 'สร้างบัญชีไม่สำเร็จ กรุณาลองใหม่อีกครั้งในภายหลัง',
      accountCreatedDirectly: 'บัญชีของคุณได้ถูกสร้างขึ้นโดยตรง!',
      theRequestHasBeenApprovedAndIsJumpingThePageForYou:
        'คำขอได้รับการอนุมัติแล้ว หน้าเว็บจะกระโดดโดยอัตโนมัติ',
      theRequestHasBeenSendAndPleaseBePatient: 'คำขอได้ถูกส่งแล้ว กรุณารอสักครู่!',
      wrongRouting: 'เกิดข้อผิดพลาดในการนำทาง หน้าเว็บจะกระโดดโดยอัตโนมัติ',
      yourRequestHasBeenDeclined:
        'คำขอของคุณถูกปฏิเสธ คุณสามารถสมัครใหม่เพื่อเข้าร่วมทีม หรือสร้างบัญชีใหม่โดยไม่ต้องใช้รหัสเชิญ',
      waitingForAdministratorReview: 'รอการตรวจสอบจากผู้ดูแลระบบ',
      thisFieldIsRequired: 'ฟิลด์นี้จำเป็นต้องกรอก',
      pleaseEnterTheResidence: 'กรุณากรอกประเทศ',
      invitationCodeDoesNotExist: 'รหัสอ้างอิงไม่ถูกต้อง',
      ifYourCompanyHaveBeenJoinedPleaseWriteHere:
        'หากคุณใช้งานผ่านการอ้างอิงจากตัวแทน กรุณากรอกรหัสอ้างอิง',
      pleaseEnterTheUsername: 'กรุณากรอกชื่อผู้ใช้',
      pleaseEnterTheCompanyName: 'กรุณากรอกชื่อบริษัท',
      needRegisterAgain: 'ของคุณมีการขอสมาชิกมากเกินไป กรุณาลองใหม่อีกครั้งในภายหลัง',
      alreadyBind: 'คุณได้อ้างอิงบริษัทแล้ว กรุณาอ้างอิงบริษัทใหม่',
    },
  },
  knowledgeFormPage: {
    name: 'ชื่อของคุณ',
    email: 'อีเมลของคุณ',
    companyName: 'ชื่อบริษัท',
    department: 'แผนก',
    role: 'ตำแหน่ง',
    country: 'ประเทศ',
    province: 'จังหวัด',
    pleaseEnter: 'กรุณากรอก',
    pleaseSelect: 'กรุณาเลือก',
    pleaseEnterTheName: 'กรุณากรอกชื่อของคุณ',
    pleaseEnterTheEmail: 'กรุณากรอกอีเมลของคุณ',
    pleaseEnterValidEmail: 'กรุณากรอกอีเมลที่ถูกต้อง',
    pleaseEnterTheCompanyName: 'กรุณากรอกชื่อบริษัทของคุณ',
    pleaseSelectTheDepartment: 'กรุณาเลือกแผนกของคุณ',
    pleaseSelectTheRole: 'กรุณาเลือกตำแหน่งของคุณ',
    pleaseSelectTheCountry: 'กรุณาเลือกประเทศของคุณ',
    pleaseSelectTheProvince: 'กรุณาเลือกจังหวัดของคุณ',
    textIsRequired: 'ฟิลด์นี้จำเป็นต้องกรอก',
    submit: 'ส่ง',
    download: 'ดาวน์โหลด',
    submitSuccess: 'ส่งสำเร็จ',
    downloadSuccess: 'ดาวน์โหลดสำเร็จ',
    title1: 'กรุณากรอกข้อมูลของคุณเพื่อรับทรัพยากร',
    title2: 'กรุณาเลือกทรัพยากรที่คุณต้องการดาวน์โหลด',
  },
  dashboard: {
    pdf: {
      downloadReport: 'ดาวน์โหลดรายงาน',
      downloadBtnText: 'ดาวน์โหลด PDF',
      content: 'เนื้อหา',
      theEnd: 'สิ้นสุด',
      thankYouForWatching: 'ขอบคุณที่รับชม',
      pdfProcessing: 'กำลังดำเนินการดู PDF...',
      pdfProcessingDesc:
        'PDF หน้า: {{count}}，คาดว่าจะใช้ {{seconds}} วินาที，กรุณากดบันทึกหลังจากนั้น，กรุณารอสักครู่',
      pdfProcessingDesc2: 'ภาษาปัจจุบันไม่ได้แปล，ไม่สามารถสร้าง PDF ได้',
    },
    ppt: {
      downloadBtnText: 'ดาวน์โหลด PPT',
      pptProcessingDesc: 'กำลังสร้างไฟล์ PPT โปรดรอสักครู่',
      pptProcessingDesc2: 'เวอร์ชันภาษาปัจจุบันยังไม่ได้แปล ไม่สามารถสร้าง PPT ได้',
      pptProcessingDesc3: 'กำลังดาวน์โหลดไฟล์ PPT โปรดรอสักครู่...',
      translateCompleted: 'แปล PPT เสร็จสิ้น',
      exportSuccess: 'ส่งออกไฟล์ PPT สำเร็จ',
      exportFailed: 'ส่งออกไฟล์ PPT ไม่สำเร็จ',
    },
    layout: {
      projectMenuText: 'โปรเจกต์การทดสอบโฆษณา',
      accountManagementText: 'การจัดการบัญชี',
      myAccountText: 'บัญชีของฉัน',
      subscriptionText: 'การสมัครสมาชิก',
      logout: 'ออกจากระบบ',
      dataDetails: 'รายละเอียดข้อมูล',
      dataAnalysis: 'การวิเคราะห์ข้อมูล',
      dataOverview: 'ภาพรวมข้อมูล',
      dataComparison: 'การเปรียบเทียบข้อมูล',
    },
    systemMessage: {
      title: 'ข้อความระบบ',
      task: 'งาน',
      system: 'ระบบ',
      noRelevantContent: 'ไม่พบเนื้อหาที่เกี่ยวข้อง',
      noMore: 'ไม่มีข้อความเพิ่มเติม',
    },
    projectPage: {
      createProject: 'สร้างโปรเจกต์',
      searchPlaceholder: 'กรอกชื่อโปรเจกต์/โฆษณา/แบรนด์เพื่อค้นหา',
      sortLabel: 'การเรียงลำดับตามดัชนีประสิทธิภาพโฆษณา',
      sortPlaceholder: 'เลือกวิธีเรียงลำดับ',
      sortOption1: 'เรียงลำดับจากน้อยไปมากตามดัชนีประสิทธิภาพ',
      sortOption2: 'เรียงลำดับจากมากไปน้อยตามดัชนีประสิทธิภาพ',
      filterSort: 'กรองและเรียงลำดับ',
      filterBenchmarkTitle: 'กรองเกณฑ์อ้างอิง',
      sortTitle: 'เรียงลำดับ',
      tabAllCreative: 'ครีเอทีฟทั้งหมด ({{count}})',
      tabGeneralCreative: 'ครีเอทีฟปกติ ({{count}})',
      tabSplashCreative: 'ครีเอทีฟเปิดหน้าจอ ({{count}})',
      generalCreativeLabel: 'ครีเอทีฟปกติ',
      splashCreativeLabel: 'ครีเอทีฟเปิดหน้าจอ',
      normTypePlaceholder: 'กรุณาเลือกประเภทค่ามาตรฐาน',
      totalDesc: 'โปรเจกต์โฆษณา (ทั้งหมด {{total}})',
      noRelevantContent: 'ไม่พบเนื้อหาที่เกี่ยวข้อง',
      loadMore: 'โหลดเพิ่มเติม',
      projectCard: { delete: 'ลบ', reanalyze: 'วิเคราะห์ใหม่', download: 'ดาวน์โหลด' },
      delete: 'ลบ',
      cancel: 'ยกเลิก',
      message: {
        deleteTitle: 'คำเตือนการลบ',
        delete:
          'เมื่อคุณลบโปรเจกต์นี้ ข้อมูลที่เกี่ยวข้องทั้งหมดจะไม่สามารถเข้าถึงได้ คุณแน่ใจหรือไม่ว่าต้องการดำเนินการลบ?',
        delete1: 'โปรเจกต์นี้เป็นโปรเจกต์ทดสอบฟรี การลบจะไม่ส่งผลต่อสิทธิ์ทดสอบฟรี',
        delete2:
          'โปรเจกต์นี้ยังไม่ได้เริ่มการวิเคราะห์ หลังจากลบแล้ว เครดิตการทดสอบของคุณจะได้รับการคืนเงิน',
        deleteSuccess: 'ลบสำเร็จ!',
        analysisCountNotEnough: 'จำนวนการวิเคราะห์ไม่เพียงพอ กรุณาชาร์จเพิ่มเติม',
        analysisFailed: 'การวิเคราะห์ล้มเหลว กรุณาลองใหม่อีกครั้ง',
        waitingQuestion:
          'สามารถวิเคราะห์โปรเจกต์พร้อมกันได้สูงสุด 3 โปรเจกต์ โปรเจกต์นี้ได้เข้าสู่คิวการรอแล้ว และจะเริ่มการวิเคราะห์โดยอัตโนมัติในภายหลัง',
        landscapeQuickCompleted: 'โปรเจกต์ทดสอบด่วนแนวนอนของคุณเสร็จสมบูรณ์แล้ว',
        portraitQuickCompleted: 'โปรเจกต์ทดสอบด่วนแนวตั้งของคุณเสร็จสมบูรณ์แล้ว',
        landscapeSurveyCompleted: 'โปรเจกต์อินไซต์เชิงลึกแนวนอนของคุณเสร็จสมบูรณ์แล้ว',
        portraitSurveyCompleted: 'โปรเจกต์อินไซต์เชิงลึกแนวตั้งของคุณเสร็จสมบูรณ์แล้ว',
      },
    },
    projectCreatePage: {
      createProject: 'สร้างโปรเจกต์',
      basicInformation: 'ข้อมูลพื้นฐาน',
      projectType: 'ประเภทโปรเจกต์',
      projectName: 'ชื่อโปรเจกต์',
      categoryType: 'อุตสาหกรรม',
      brandName: 'ชื่อแบรนด์',
      advertisingInformation: 'ข้อมูลโฆษณา',
      adName: 'ชื่อโฆษณา',
      norm: 'ค่าพื้นฐาน',
      targetMarketNorm: 'ค่าพื้นฐานของตลาดเป้าหมาย',
      brandNorm: 'ค่าพื้นฐานแบรนด์',
      taGender: 'เพศ TA',
      targetMarket: 'ตลาดเป้าหมาย',
      taAge: 'อายุ TA',
      next: 'ถัดไป',
      previous: 'ก่อนหน้า',
      confirmOrder: 'ยืนยันคำสั่ง',
      estTime: 'เวลาที่คาดการณ์',
      minutes: 'นาที',
      consumption: 'การใช้จ่ายในคำสั่งนี้',
      testPoint: 'จำนวนการทดสอบ',
      remaining: 'ที่เหลือ',
      times: 'ครั้ง',
      type: 'ประเภท',
      purchase: 'การซื้อ',
      outputLanguage: 'ภาษาขาออก',
      durationCategory: 'ประเภทครีเอทีฟ',
      durationCategoryDesc: 'ตัวชี้วัดการวิเคราะห์จะแตกต่างกันตามประเภทครีเอทีฟ กรุณาเลือกตัวเลือกที่เหมาะกับคอนเทนต์ของคุณมากที่สุด',
      durationCategoryOptions: {
        tenPlus: 'ครีเอทีฟทั่วไป (10วิ+)',
        fiveToTen: 'ครีเอทีฟเปิดเรื่อง (5-10วิ)',
      },
      adSelection: {
        adCreativeTest: 'การทดสอบความคิดสร้างสรรค์โฆษณา',
        adCreativeTestDesc:
          'ทดสอบการตอบรับของกลุ่มเป้าหมายต่อความคิดสร้างสรรค์โฆษณาเดียว ให้การวิเคราะห์และคำแนะนำ',
        adCreativeSelection: 'การคัดเลือกความคิดสร้างสรรค์โฆษณา',
        adCreativeSelectionDesc:
          'เปรียบเทียบผลตอบรับจากความคิดสร้างสรรค์โฆษณาหลายรายการ เลือกอย่างรอบคอบ',
        adCreativeEditing: 'การตัดต่อความคิดสร้างสรรค์โฆษณา',
        adCreativeEditingDesc:
          'AI คัดกรองส่วนที่ดีที่สุดจากความคิดสร้างสรรค์โฆษณา สร้างความคิดสร้างสรรค์โฆษณาโดยอัตโนมัติ',
        launchingSoon: 'เร็วๆ นี้',
      },
      industryCategorySelect: {
        /**----------------------- */
        foodAndBeverageCategory: 'อุตสาหกรรมอาหาร/เครื่องดื่ม',
        packagedFood: 'อาหารพลอย',
        confectionery: 'ขนม/ของหวาน',
        frozenMeals: 'อาหารแช่แข็ง',
        fastFood: 'อาหารที่ทำได้รวดเร็ว',
        beverage: 'เครื่องดื่ม',
        alcohol: 'เหล้า',
        dairy: 'นม',
        grainAndSeasoning: 'ขนมปัง/ซอส',
        beverageMixes: 'นมสด/นมพลอย',
        freshProduce: 'ผัก/ผลไม้',
        otherFoodAndBeverage: 'อื่นๆ',
        /**----------------------- */
        consumerElectronicsCategory: 'อุตสาหกรรมอุปกรณ์ไฟฟ้า',
        mobilePhone: 'สมาร์ทโฟน',
        computer: 'คอมพิวเตอร์',
        smartDevice: 'อุปกรณ์อัจฉริยะ',
        phoneAccessories: 'อุปกรณ์สำหรับสมาร์ทโฟน',
        computerAccessories: 'อุปกรณ์สำหรับคอมพิวเตอร์',
        software: 'ซอฟแวร์',
        camera: 'กล้องถ่ายรูป',
        officeSupplies: 'อุปกรณ์สำหรับทำงาน',
        otherConsumerElectronics: 'อื่นๆ',
        /**----------------------- */
        pharmaceuticalsAndHealthCareCategory: 'อุตสาหกรรมยา/สุขภาพ',
        otcMedicine: 'ยาไม่ต้องรับประทาน',
        prescriptionDrugs: 'ยาเคมี',
        healthSupplements: 'ยาเสริมสุขภาพ',
        pharmaceuticalCompanies: 'บริษัทยา',
        medicalDevices: 'อุปกรณ์ทางการแพทย์',
        medicalServices: 'บริการทางการแพทย์',
        pharmacy: 'ร้านยา',
        otherPharmaceuticalsAndHealthCare: 'อื่นๆ',
        /**----------------------- */
        beautyAndPersonalCareCategory: 'อุตสาหกรรมสุขภาพ/สุขภาพสะอาด',
        hairCare: 'การดูแลผม',
        womenSkincare: 'การดูแลผิวสวม',
        homeCleaning: 'การดูแลบ้าน',
        bodyCare: 'การดูแลร่างกาย',
        feminineCare: 'การดูแลสุขภาพสตรี',
        oralCare: 'การดูแลปาก',
        menSkincare: 'การดูแลผมชาย',
        makeup: 'การดูแลสุขภาพสตรี',
        fragrances: 'การดูแลสุขภาพสตรี',
        beautyServices: 'บริการสุขภาพสตรี',
        otherBeautyAndPersonalCare: 'อื่นๆ',
        /**----------------------- */
        maternalAndInfantProductsCategory: 'อุตสาหกรรมสุขภาพสตรี/สุขภาพสตรี',
        babyFood: 'อาหารสำหรับทารก',
        babyCareEssentials: 'อุปกรณ์สำหรับทารก',
        babyToys: 'อุปกรณ์สำหรับทารก',
        otherMaternalAndInfantProducts: 'อื่นๆ',
        /**----------------------- */
        networkAndCommunicationCategory: 'อุตสาหกรรมการสื่อสาร',
        mobileCarriers: 'ผู้ให้บริการสื่อสารมือถือ',
        internetProviders: 'ผู้ให้บริการอินเทอร์เน็ต',
        telecomEquipment: 'อุปกรณ์สื่อสาร',
        otherNetworkAndCommunication: 'อื่นๆ',
        /**----------------------- */
        travelAndAccommodationCategory: 'อุตสาหกรรมการเดินทาง/ที่พัก',
        localTourism: 'การเดินทาง/ที่พัก',
        bookingPlatform: 'การจองที่พัก',
        hotels: 'ที่พัก',
        airlines: 'การบิน',
        airport: 'สนามบิน',
        otherTravelAndAccommodation: 'อื่นๆ',
        /**----------------------- */
        vehiclesCategory: 'อุตสาหกรรมการขนส่ง',
        motorVehicleProductsAndServices: 'อุปกรณ์การขนส่งสินค้า',
        carBrands: 'ยี่ห้อรถ',
        dealerships: 'ร้านค้ารถ',
        carFinance: 'การเงินรถ',
        evCar: 'รถยนต์อิเล็กทริก',
        motorcycle: 'มอเตอร์ไซค์',
        onlineUsedCarMarketplace: 'ตลาดรถยนต์ออนไลน์',
        carRentalPlatform: 'ระบบจองรถยนต์',
        travelNavigation: 'การเดินทาง',
        bicycle: 'จักรยาน',
        otherVehicles: 'อื่นๆ',
        /**----------------------- */
        householdAppliancesCategory: 'อุตสาหกรรมอุปกรณ์ใช้สอย',
        majorAppliances: 'อุปกรณ์ใช้สอยขนาดใหญ่',
        healthAndPersonalCareAppliances: 'อุปกรณ์ใช้สอยสุขภาพ',
        majorKitchenAndBathAppliances: 'อุปกรณ์ใช้สอยที่มีขนาดใหญ่',
        smallKitchenAppliances: 'อุปกรณ์ใช้สอยที่มีขนาดเล็ก',
        environmentalAppliances: 'อุปกรณ์ใช้สอยสิ่งแวดล้อม',
        cleaningAppliances: 'อุปกรณ์ใช้สอยสะอาด',
        otherHouseholdAppliances: 'อื่นๆ',
        /**----------------------- */
        retailAndServiceCategory: 'อุตสาหกรรมการขาย/บริการ',
        onlineRetailEcommerce: 'การขายออนไลน์/อีเคมาร์ค',
        departmentStores: 'ร้านค้าสำหรับคนทั่วไป',
        lifeServices: 'บริการชีวิต',
        retailServicesAndDelivery: 'การขายสินค้า/การจัดส่ง',
        supermarkets: 'ร้านค้าขนาดใหญ่',
        otherRetailAndService: 'อื่นๆ',
        /**----------------------- */
        apparelCategory: 'อุตสาหกรรมเสริมสวย',
        footwear: 'รองเท้า',
        clothing: 'เสื้อผ้า',
        watchesWatchRetail: 'นาฬิกา/ร้านนาฬิกา',
        jewelry: 'อุปกรณ์สวย',
        bags: 'กระเป๋า',
        eyewearOpticalStores: 'กล้องตา/ร้านกล้องตา',
        otherClothingAndAccessories: 'อื่นๆ',
        /**----------------------- */
        homeImprovementAndFurnishingsCategory: 'อุตสาหกรรมการปรับแต่งบ้าน',
        homeFurnishing: 'อุปกรณ์บ้าน',
        homeImprovement: 'อุปกรณ์บ้าน',
        otherHomeImprovementAndFurnishings: 'อื่นๆ',
        /**----------------------- */
        financialAndInsuranceCategory: 'อุตสาหกรรมการเงิน/ประกัน',
        bank: 'ธนาคาร',
        fintech: 'ธนาคารออนไลน์',
        investmentAndFinancialServices: 'การลงทุน',
        insurance: 'ประกัน',
        otherFinancialAndInsurance: 'อื่นๆ',
        /**----------------------- */
        entertainmentAndLeisureCategory: 'อุตสาหกรรมการสนุก/สนุก',
        socialApp: 'แอปพลิเคชันสังคม',
        toysAndDolls: 'เล่นสนุก',
        concerts: 'คอนเสริม',
        events: 'กิจกรรม',
        movies: 'ภาพยนตร์',
        themeParks: 'พาร์คที่มีชื่อเสียง',
        gambling: 'การพนัน',
        onlineGaming: 'การเล่นเกมออนไลน์',
        tvChannels: 'ช่องทีวี',
        otherEntertainmentAndLeisure: 'อื่นๆ',
        /**----------------------- */
        industrialAndAgriculturalCategory: 'อุตสาหกรรมการประมง/การเกษตร',
        industrialSupplies: 'อุปกรณ์อุตสาหกรรม',
        agriculturalSupplies: 'อุปกรณ์เกษตร',
        otherIndustrialAndAgricultural: 'อื่นๆ',
        /**----------------------- */
        petLifeCategory: 'อุตสาหกรรมสัตว์',
        petFood: 'อาหารสัตว์',
        petSupplies: 'อุปกรณ์สัตว์',
        otherPetLife: 'อื่นๆ',
        /**----------------------- */
        educationAndLearningCategory: 'อุตสาหกรรมการศึกษา/การเรียนรู้',
        onlineLearning: 'การเรียนรู้ออนไลน์',
        schools: 'สถาบันการศึกษา',
        skillCourses: 'คอร์สที่สอนทักษะ',
        tutoring: 'การสอนพิเศษ',
        universities: 'มหาวิทยาลัย',
        otherEducationAndLearning: 'อื่นๆ',
        /**----------------------- */
        communityAndPublicServiceCategory: 'อุตสาหกรรมการสังคม/การบริการสาธารณะ',
        charityCampaigns: 'การรณรงค์กุศล',
        ngoAds: 'การโฆษณากุศล',
        otherCommunityAndPublicService: 'อื่นๆ',
        /**----------------------- */
        otherCategory: 'อื่นๆ',
        governmentAdvertising: 'การโฆษณารัฐบาล',
        realEstateAdvertising: 'การโฆษณาอสังหาริมทรัพย์',
        otherAdvertising: 'อื่นๆ',
      },
      genderSelect: {
        male: 'ชาย',
        female: 'หญิง',
        all: 'ทั้งหมด',
      },
      targetMarketSelect: {
        China: 'จีน',
        HongKongChina: 'ฮ่องกง, จีน',
        MacauChina: 'มาเก๊า, จีน',
        TaiwanChina: 'ไต้หวัน, จีน',
        Japan: 'ญี่ปุ่น',
        Korea: 'เกาหลี',
        Mongolia: 'มองโกเลีย',
        Singapore: 'สิงคโปร์',
        Thailand: 'ไทย',
        Vietnam: 'เวียดนาม',
        Malaysia: 'มาเลเซีย',
        Philippines: 'ฟิลิปปินส์',
        Indonesia: 'อินโดนีเซีย',
        Cambodia: 'กัมพูชา',
        Laos: 'ลาว',
        India: 'อินเดีย',
        SaudiArabia: 'ซาอุดีอาระเบีย',
        Turkey: 'ตุรกี',
        Israel: 'อิสราเอล',
        UnitedArabEmirates: 'สหรัฐอาหรับเอมิเรตส์',
        Qatar: 'กาตาร์',
        Kuwait: 'คูเวต',
        UnitedKingdom: 'สหราชอาณาจักร',
        France: 'ฝรั่งเศส',
        Germany: 'เยอรมนี',
        Netherlands: 'เนเธอร์แลนด์',
        Belgium: 'เบลเยียม',
        Austria: 'ออสเตรีย',
        Italy: 'อิตาลี',
        Spain: 'สเปน',
        Portugal: 'โปรตุเกส',
        Greece: 'กรีซ',
        Sweden: 'สวีเดน',
        Norway: 'นอร์เวย์',
        Finland: 'ฟินแลนด์',
        Denmark: 'เดนมาร์ก',
        Estonia: 'เอสโตเนีย',
        Latvia: 'ลัตเวีย',
        Russia: 'รัสเซีย',
        Poland: 'โปแลนด์',
        CzechRepublic: 'สาธารณรัฐเช็ก',
        Hungary: 'ฮังการี',
        Romania: 'โรมาเนีย',
        Bulgaria: 'บัลแกเรีย',
        Slovakia: 'สโลวาเกีย',
        Slovenia: 'สโลวีเนีย',
        Ukraine: 'ยูเครน',
        UnitedStates: 'สหรัฐอเมริกา',
        Canada: 'แคนาดา',
        Mexico: 'เม็กซิโก',
        Brazil: 'บราซิล',
        LatinAmerica: 'ลาตินอเมริกา',
        Australia: 'ออสเตรเลีย',
        NewZealand: 'นิวซีแลนด์',
        Other: 'อื่นๆ',
      },
      languageSelect: {
        english: 'อังกฤษ',
        chinese: 'จีน',
        japanese: 'ญี่ปุ่น',
        korean: 'เกาหลี',
        french: 'ฝรั่งเศส',
        traditionalChinese: 'จีนตัวเต็ม',
      },
      placeholder: {
        projectName: 'กรอกชื่อโปรเจกต์',
        category: 'เลือกหมวดหมู่',
        brandName: 'กรอกชื่อแบรนด์',
        adName: 'กรอกชื่อโฆษณา',
        norm: 'โปรดเลือกค่ามาตรฐาน',
        taGender: 'เลือกเพศ',
        targetMarket: 'เลือกตลาดเป้าหมาย',
        taAge: 'เลือกอายุ',
        lowerLimit: 'ขีดล่าง',
        upperLimit: 'ขีดบน',
        outputLanguage: 'เลือกภาษาขาออก',
      },
      step: {
        step1: 'กรอกข้อมูลโปรเจกต์',
        step2: 'ยืนยันข้อมูลคำสั่ง',
      },
      message: {
        success: 'สร้างสำเร็จ',
        videoDurationOver60s: 'ความยาววิดีโอเกิน {{max}} วินาที',
        videoDurationLessThan10s: 'ความยาววิดีโอไม่ถึง {{min}} วินาที',
        videoDurationNeedOver10s: 'ความยาววิดีโอต้องมากกว่า 10 วินาที',
        videoDurationNeedWithin5To10s: 'ความยาววิดีโอต้องอยู่ระหว่าง 5 ถึง 10 วินาที',
        videoDurationNotMatchDurationCategory: 'ความยาววิดีโอปัจจุบันไม่ตรงตามประเภทโปรเจกต์นี้ โปรดอัปโหลดวิดีโอใหม่แล้วลองอีกครั้ง',
        videoUploadingCannotSwitchDurationCategory: 'ไม่สามารถเปลี่ยนประเภทครีเอทีฟขณะอัปโหลดวิดีโอได้ โปรดรอให้อัปโหลดเสร็จสิ้น',
        videoFormatOrDurationError: 'ไม่สามารถอ่านรูปแบบหรือความยาวของวิดีโอได้ โปรดตรวจสอบไฟล์วิดีโอแล้วลองอีกครั้ง',
        videoSizeOver200M: 'ขนาดวิดีโอเกิน 256MB',
        videoLandscape: 'วิดีโอต้องเป็นรูปแบบดิ่ง',
        videoPortrait: 'วิดีโอต้องเป็นแนวตั้ง',
        clickToUploadTestVideo: 'คลิกเพื่ออัปโหลดวิดีโอทดสอบ',
        uploadFailed: 'การอัปโหลดล้มเหลว กรุณาลองใหม่',
        uploadDesc1: 'รองรับไฟล์วิดีโอในรูปแบบดิ่ง รูปแบบ MP4, MOV',
        uploadDescPortrait: 'รองรับไฟล์วิดีโอแนวตั้งในรูปแบบ MP4, MOV',
        uploadDesc2: 'รูปแบบอื่น ขนาดไฟล์จำกัดที่ 256MB ขึ้นไป',
        formNotCompleted: 'กรุณากรอกข้อมูลให้ครบถ้วน',
        uploadAdVideo: 'กรุณาอัปโหลดวิดีโอโฆษณา',
        inputInvalid: 'ข้อมูลที่ป้อนไม่ถูกต้อง',
        insufficientTestPoints: 'คะแนนทดสอบไม่เพียงพอ กรุณาเติมเงินแล้วลองอีกครั้ง',
        reviewProjectInfo:
          'กรุณาตรวจสอบข้อมูลโปรเจกต์ของคุณอย่างละเอียด เมื่อยืนยันคำสั่งแล้วจะไม่สามารถเปลี่ยนแปลงได้',
        waitingDesc:
          'สามารถวิเคราะห์โปรเจกต์พร้อมกันได้สูงสุด 3 โปรเจกต์ โปรเจกต์นี้ได้เข้าสู่คิวการรอแล้ว และจะเริ่มการวิเคราะห์โดยอัตโนมัติในภายหลัง',
        ageRangeInvalid: 'ช่วงอายุรองรับเฉพาะ 20-55',
        normDesc: 'สิทธิ์ลิขสิทธิ์ไม่จำกัด มาตรฐานที่บริษัทกำหนดเอง',
      },
    },
    projectDetailPage: {
      testResults: 'ผลการทดสอบ',
      share: 'แชร์',
      shareFailed: 'แชร์ไม่สำเร็จ',
      shareModal: {
        title: 'แชร์',
        desc: 'คัดลอกข้อความด้านล่างและแชร์บนโซเชียลมีเดีย',
        saveImage: 'บันทึกรูปภาพ',
        copyText: 'คัดลอกข้อความ',
        copySuccess: 'คัดลอกแล้ว',
        copyFailed: 'คัดลอกไม่สำเร็จ',
        textTemplate:
          'ว้าว! ครีเอทีฟ AI ของฉันเอาชนะผลงานที่คล้ายกันบน AdEff ได้ถึง {{score}}%! ข้อมูลนี่แหละของจริง! ตอนนี้ AdEff AI Creative Testing เปิดให้ใช้ฟรีแล้ว ตรวจสอบคะแนนของคุณได้ที่ {{hostname}} รับสิทธิ์ทดสอบฟรี 5 ครั้ง ขอให้คุณได้รีวิวปัง ๆ!',
      },
      sharePoster: {
        createdByYou: 'ผลงานที่คุณสร้าง',
        scoreTemplate: 'สูงกว่า <score>{{score}}</score> ของครีเอทีฟ AIGC',
        statsAt: 'สถิติ ณ ',
        certification: 'การรับรองความคิดสร้างสรรค์',
        footerText: 'หวังว่าคุณจะสร้างสรรค์ต่อเนื่องและนำผลงานคุณภาพมาอีกมากมาย!',
      },
      basicInformation: 'ข้อมูลพื้นฐาน',
      waiting: 'รอการดำเนินการ',
      ongoing: 'กำลังดำเนินการ',
      failed: 'ล้มเหลว',
      tryAgain: 'ลองอีกครั้ง',
      videoAnalysisFailed: 'การวิเคราะห์วิดีโอล้มเหลว',
      message: { projectNotFound: 'ไม่พบโปรเจกต์' },
      primaryAnalysis: 'ประสิทธิภาพหลัก',
      detailAnalysis: 'การวิเคราะห์รายละเอียด',
      heatmapAnalysis: 'แผนที่ความร้อน',
      analysisStepDesc: 'AI ได้ทำการวิเคราะห์ทั้งหมดเสร็จสิ้น การวิเคราะห์รายละเอียดมีดังนี้',
      analysisWaitingDesc:
        'สามารถวิเคราะห์โปรเจกต์พร้อมกันได้สูงสุด 3 โปรเจกต์ โปรเจกต์นี้ได้เข้าสู่คิวการรอแล้ว และจะเริ่มการวิเคราะห์โดยอัตโนมัติในภายหลัง',
      aiTip: 'ข้อมูลการวิเคราะห์ถูกสร้างโดย AI เท่านั้น สำหรับการอ้างอิงเท่านั้น',
      subAnalysisDescription: {
        adVideoScore: 'ดัชนีประสิทธิภาพโฆษณา',
        adVideoScoreDesc:
          'ดัชนีประสิทธิภาพโฆษณาเป็นดัชนีทั่วไปที่สามารถคาดการณ์ประสิทธิภาพของโฆษณาในระยะสั้นและยาว',
        norm: 'ค่ามาตรฐาน',
        normDesc:
          'ค่ามาตรฐานจากข้อมูลอุตสาหกรรมหรือประวัติศาสตร์ ใช้สำหรับการเปรียบเทียบประสิทธิภาพโฆษณา',
        attentionIndex: 'ดัชนีความสนใจ',
        attentionIndexDesc:
          'ระดับความสนใจของผู้ชมที่มองไปที่โฆษณา สะท้อนถึงความสามารถขององค์ประกอบและเนื้อหาในการดึงดูดความสนใจ',
        emotionIndex: 'ดัชนีอารมณ์',
        emotionIndexDesc:
          'ระดับอารมณ์เชิงบวกที่กระตุ้นโดยโฆษณา สะท้อนถึงการเปลี่ยนแปลงอารมณ์ที่เกิดขึ้นทันที',
        cognitionIndex: 'ดัชนีการรับรู้',
        cognitionIndexDesc:
          'สะท้อนถึงระดับการประมวลผลทางปัญญาของผู้ชม ว่าพวกเขาคิดเกี่ยวกับเนื้อหาโฆษณาในระดับใด',
        theGolden3Seconds: 'สามวินาทีทอง',
        theGolden3SecondsDesc:
          'สามวินาทีแรกของโฆษณาคือช่วงเวลาที่สำคัญในการตัดสินใจความสำเร็จของโฆษณา',
        informationTransmission: 'ช่วงเวลาข้อมูล',
        informationTransmissionDesc:
          'วัดความสามารถของช่วงเวลาข้อมูลในการดึงดูดความสนใจของกลุ่มเป้าหมายและกระตุ้นความสนใจ',
        brandRelevance: 'ช่วงเวลาของแบรนด์',
        brandRelevanceDesc:
          'วัดความสามารถของช่วงเวลาของแบรนด์ในการดึงดูดความสนใจของกลุ่มเป้าหมายและกระตุ้นความสนใจ',
        interestStimulation: 'ช่วงเวลาที่กระตุ้นความสนใจ',
        interestStimulationDesc: 'ช่วงเวลาที่สำคัญในการกระตุ้นความรู้สึกและการรับรู้ของผู้ชม',
        theEnding3Seconds: 'สามวินาทีสุดท้าย',
        theEnding3SecondsDesc:
          'ตามกฎพีค-สุดท้าย สามวินาทีสุดท้ายของโฆษณาคือช่วงเวลาที่สำคัญในการเสริมสร้างความสนใจและการส่งข้อมูล',
      },
      infoDrawer: {
        basicInformation: 'ข้อมูลพื้นฐาน',
        advertisingInformation: 'ข้อมูลโฆษณา',
        projectName: 'ชื่อโปรเจกต์',
        brandName: 'ชื่อแบรนด์',
        category: 'อุตสาหกรรม',
        norm: 'ค่าพื้นฐานของตลาดเป้าหมาย',
        normLabel: 'ค่าพื้นฐาน',
        brandNorm: 'ค่ามาตรฐานแบรนด์',
        adName: 'ชื่อโฆษณา',
        taGender: 'เพศ TA',
        targetMarket: 'ตลาดเป้าหมาย',
        taAge: 'อายุ TA',
        ageRange: '{{start}} ถึง {{end}} ปี',
        modify: 'แก้ไข',
        cancel: 'ยกเลิก',
        confirm: 'ยืนยัน',
      },
      videoView: {
        eyeMovementRatio: 'ดัชนีความสนใจ',
        cognitiveEngagement: 'ดัชนีการรับรู้',
        emotionRecognition: 'ดัชนีอารมณ์',
        subjectiveResponseCurve: 'กราฟการตอบสนองเชิงอัตนัย',
        realtimeData: 'ข้อมูลจริงเวลา',
        panoramicData: 'ข้อมูลพานาฮอม',
        indexAnalysis: 'การวิเคราะห์ดัชนี',
        advantage: 'ข้อดี',
        disadvantage: 'ข้อเสีย',
        suggestions: 'ข้อเสนอแนะ',
        adVideoScore: 'ดัชนีประสิทธิภาพโฆษณา',
        norm: 'ค่ามาตรฐาน',
        analysisStepTitle1: 'การถอดรหัสเนื้อหา',
        analysisStepTitle2: 'การคาดการณ์การตอบรับ',
        analysisStepTitle3: 'การรวมข้อมูล',
        analysisStepTitle4: 'การสรุปผล',
        analysisStepDesc1:
          'เริ่มการถอดรหัสเนื้อหาของโฆษณาในหลายมิติ ถอดรหัสภาพ เสียง ข้อความ และโครงสร้าง...',
        analysisStepDesc2:
          'เริ่มการคาดการณ์การตอบสนองเชิงอัตนัยของผู้ชม โดยอิงจากเนื้อหาโฆษณาในแต่ละวินาที คาดการณ์ข้อมูลการเคลื่อนไหวของตาและ EEG ของผู้ชม...',
        analysisStepDesc3:
          'เริ่มการรวมข้อมูลเนื้อหาเชิงวัตถุของโฆษณากับข้อมูลการตอบสนองเชิงอัตนัยของผู้ชม...',
        analysisStepDesc4:
          'เริ่มการสร้างข้อสรุปการประเมินและข้อเสนอแนะการดำเนินการตามโมเดลการสรุป...',
        keyResult: 'ผลลัพธ์หลัก',
        videoChart: {
          videoFailed: 'การแสดงผลวิดีโอล้มเหลว',
          videoFailedAction:
            'กรุณารีเฟรชและลองใหม่ ถ้าปัญหายังคงมีอยู่หลังจากรีเฟรชหลายครั้ง กรุณาติดต่อเราเพื่อขอความช่วยเหลือ',
        },
      },
      storyboardView: {
        summary: 'สรุป',
        advantages: 'ข้อดี',
        disadvantages: 'ข้อเสีย',
        suggestions: 'ข้อเสนอแนะ',
        keyResult: 'ผลลัพธ์หลัก',
        norm: 'ค่ามาตรฐาน',
        theGolden3Seconds: 'สามวินาทีทอง',
        informationTransmission: 'ช่วงเวลาข้อมูล',
        brandRelevance: 'ช่วงเวลาของแบรนด์',
        interestStimulation: 'ช่วงเวลาที่กระตุ้นความสนใจ',
        theEnding3Seconds: 'สามวินาทีสุดท้าย',
      },
      heatmapView: {},
    },
    accountPage: {
      email: 'อีเมล',
      username: 'ชื่อผู้ใช้',
      password: 'รหัสผ่าน',
      setPasswordToEnableEmailLogin: 'ตั้งรหัสผ่านเพื่อเปิดใช้งานการเข้าสู่ระบบด้วยอีเมล',
      uid: 'UID',
      contactAndReceiveNotifications: 'ติดต่อและรับการแจ้งเตือน',
      receiveEmailsAboutAdeffLatestUpdatesWithThisEmail:
        'รับอีเมลเกี่ยวกับการอัปเดตล่าสุดของ AdEff ที่อีเมลนี้',
      myWorkspace: 'พื้นที่ทำงานของฉัน',
      newRequest: 'คำขอใหม่',
      invitationCode: 'รหัสอ้างอิง',
      userName: 'ชื่อผู้ใช้',
      invitationCodeDesc:
        'แต่ละทีมมีรหัสเชิญเฉพาะที่ใช้เพื่อขอให้ผู้ใช้ใหม่เข้าร่วมทีมระหว่างการลงทะเบียน',
      table: {
        userName: 'ชื่อผู้ใช้',
        email: 'อีเมล',
        operation: 'การดำเนินการ',
        admin: 'ผู้ดูแลระบบ',
        remove: 'ลบ',
        deny: 'ปฏิเสธ',
        approve: 'อนุมัติ',
      },
      message: {
        yourTeamIsFull:
          'ทีมของคุณเต็มแล้ว คุณสามารถติดต่อเราเพื่อขอสมาชิกเพิ่มเติมหรือเอาสมาชิกคนอื่นออก',
        invitationLinkSent: 'ลิงก์เชิญได้ถูกส่งไปยังที่อยู่อีเมลนี้!',
        removeReminder: 'เตือนการลบ',
        remove: 'ลบ',
        removeMember:
          'หลังจากลบสมาชิกแล้ว เนื้อหาที่สร้างโดยสมาชิกนั้นจะยังคงถูกเก็บรักษาไว้ คุณต้องการดำเนินการลบสมาชิกหรือไม่?',
        removeMemberSuccess: 'ลบสมาชิกสำเร็จ!',
        ok: 'ตกลง',
        contactUs: 'ติดต่อเรา',
        applicationProcessedSuccessfully: 'การประมวลผลคำขอเสร็จสิ้น!',
        notificationSettingsTurnedOn: 'การตั้งค่าการแจ้งเตือนเปิดใช้งานแล้ว',
        notificationSettingsTurnedOff: 'การตั้งค่าการแจ้งเตือนปิดอยู่',
        setPassword: 'ตั้งรหัสผ่าน',
        passwordConfirm: 'ยืนยัน',
        passwordCancel: 'ยกเลิก',
        oldPassword: 'รหัสผ่านเก่า',
        newPassword: 'รหัสผ่านใหม่',
        pleaseEnterTheOldPassword: 'กรุณากรอกรหัสผ่านเก่า',
        pleaseEnterTheNewPassword: 'กรุณากรอกรหัสผ่านใหม่',
        incorrectEntryOfOriginalPassword: 'การป้อนรหัสผ่านต้นฉบับไม่ถูกต้อง',
        passwordUpdatedSuccessfully: 'อัปเดตรหัสผ่านสำเร็จ',
        changeUsername: 'เปลี่ยนชื่อผู้ใช้',
        confirm: 'ยืนยัน',
        cancel: 'ยกเลิก',
        username: 'ชื่อผู้ใช้',
        pleaseEnterTheNewUsername: 'กรุณากรอกชื่อผู้ใช้ใหม่',
        userNameUpdatedSuccessfully: 'อัปเดตชื่อผู้ใช้สำเร็จ',
        addMemberToWorkspace: 'เพิ่มสมาชิกใหม่ในพื้นที่ทำงาน',
        notAdminOperate: 'ไม่ใช่ผู้ดูแลระบบ ไม่สามารถดำเนินการได้',
        emailAddress: 'ที่อยู่อีเมล',
        send: 'ส่ง',
        willSendAnInvitationEmailToThisAddressForConfirmation:
          'เราจะส่งอีเมลเชิญไปยังที่อยู่นี้เพื่อยืนยัน',
        workspaceMemberShip: 'การเป็นสมาชิกในพื้นที่ทำงาน',
        forMoreMembership: 'สำหรับการเป็นสมาชิกเพิ่มเติม',
        reachedTheCeiling: 'จำนวนถึงขีดจำกัดแล้ว',
        incorrectMailboxFormat: 'รูปแบบอีเมลไม่ถูกต้อง',
        member: 'สมาชิก',
        changeCorpNameTitle: 'เปลี่ยนชื่อบริษัท',
        changeCorpNameLabel: 'ชื่อบริษัท',
        pleaseEnterTheCorpName: 'กรุณากรอกชื่อบริษัท',
        changeCorpNameSuccess: 'ชื่อบริษัทถูกเปลี่ยนสำเร็จ',
        changeCorpNameFailed: 'เปลี่ยนชื่อบริษัทไม่สำเร็จ',
        noPermission: 'คุณไม่มีสิทธิ์เปลี่ยนชื่อบริษัท',
      },
    },
    subscriptionPage: {
      currentPlan: 'แผนปัจจุบัน',
      getInvoice: 'รับใบแจ้งหนี้ของคุณ',
      remainingTimes: 'จำนวนครั้งที่เหลือ',
      purchaseMore: 'ซื้อเพิ่มเติม',
      contactUs: 'ติดต่อเรา',
      teamPlan: 'บริการทีมผู้เชี่ยวชาญ',
      unlimited: 'ไม่จำกัด',
      dueDate: 'วันหมดอายุ',
      table: {
        usageRecords: 'บันทึกการใช้งาน',
        date: 'วันที่',
        projectName: 'ชื่อโปรเจกต์',
        projectType: 'ประเภทโปรเจกต์',
        usageCount: 'ครั้ง',
        userName: 'ชื่อผู้ใช้',
        noRelevantContent: 'ไม่พบเนื้อหาที่เกี่ยวข้อง',
      },
    },
    portraitDataDetailPage: {
      regularCreativeProject: 'โปรเจกต์ครีเอทีฟปกติ',
      regularCreative: 'ครีเอทีฟปกติ',
      splashCreativeProject: 'โปรเจกต์ครีเอทีฟเปิดหน้าจอ',
      splashCreative: 'ครีเอทีฟเปิดหน้าจอ',
      projects: 'โปรเจกต์',
      localNorm: 'เกณฑ์อ้างอิงท้องถิ่น',
      projectPassRate: 'อัตราผ่านของโปรเจกต์',
      passRate: 'อัตราผ่าน',
    },
    dataDetailPage: {
      baseData: 'ข้อมูลพื้นฐาน',
      totalProjects: 'จำนวนโปรเจกต์ทั้งหมด',
      totalProjectsDesc: 'จำนวนโปรเจกต์ทั้งหมดที่เข้าร่วมการประเมินประสิทธิภาพโฆษณา',
      // averageEffectivenessIndex: 'ดัชนีประสิทธิภาพโฆษณาเฉลี่ย',
      // averageEffectivenessIndexDesc:
      // 'ดัชนีประสิทธิภาพโฆษณาเฉลี่ยของทั้งหมดโปรเจกต์ที่เข้าร่วมการประเมิน',
      localNormProjects: 'โปรเจกต์ค่าพื้นฐานของตลาดเป้าหมาย',
      brandNormProjects: 'โปรเจกต์ค่ามาตรฐานแบรนด์',
      normProject: 'โปรเจกต์ค่าพื้นฐานของตลาดเป้าหมาย',
      brandNormProject: 'โปรเจกต์ค่ามาตรฐานแบรนด์',
      localNorm: 'ค่าพื้นฐานของตลาดเป้าหมาย',
      localNormDesc:
        'ค่าเฉลี่ยดัชนีประสิทธิภาพโฆษณาของโปรเจกต์ที่มีตลาดเป้าหมายเป็นประเทศที่คุณอยู่',
      norm: 'ค่ามาตรฐาน',
      brandNorm: 'ค่ามาตรฐานแบรนด์',
      brandNormDesc:
        'ค่าเฉลี่ยดัชนีประสิทธิภาพโฆษณาของโปรเจกต์ที่มีตลาดเป้าหมายเป็นประเทศที่คุณอยู่',
      localProjectPassRate: 'อัตราการผ่านโปรเจกต์ของตลาดเป้าหมาย',
      projectPassRate: 'อัตราการผ่านโปรเจกต์',
      brandProjectPassRate: 'อัตราการผ่านโปรเจกต์ของแบรนด์',
      projectPassRateDesc: 'อัตราการผ่านโปรเจกต์ของทั้งหมดโปรเจกต์ที่เข้าร่วมการประเมิน',
      advertisingEffectivenessIndexDistribution: 'การแจกแจงดัชนีประสิทธิภาพโฆษณา',
      advertisingEffectivenessIndexDistributionDesc:
        'การแจกแจงดัชนีประสิทธิภาพโฆษณาของทั้งหมดโปรเจกต์ที่เข้าร่วมการประเมิน',
      item: 'รายการ',
    },
    dataComparisonPage: {
      createCompare: 'การเปรียบเทียบใหม่',
      createCompareDesc: 'เลือกหลายโปรเจกต์เพื่อเปรียบเทียบ สูงสุด 10 โปรเจกต์',
      startCompare: 'เริ่มเปรียบเทียบ',
      compareReport: 'รายงานเปรียบเทียบ',
      searchPlaceholder: 'ค้นหาชื่อรายงานเปรียบเทียบ',
      emptyText: 'ยังไม่มีรายงานเปรียบเทียบ โปรดเลือกโปรเจกต์เพื่อเปรียบเทียบก่อน',
      searchEmptyText: 'ไม่พบรายงานเปรียบเทียบ',
      deleteTitle: 'ลบรายงานเปรียบเทียบ',
      deleteConfirm: 'คุณแน่ใจหรือไม่ว่าต้องการลบรายงานเปรียบเทียบนี้ การดำเนินการนี้ไม่สามารถย้อนกลับได้',
      projectCount: '{{count}} โปรเจกต์',
    },
    dataComparisonStartPage: {
      back: 'ย้อนกลับ',
      basicInfo: 'ข้อมูลพื้นฐาน',
      reportName: 'ชื่อรายงาน:',
      reportNamePlaceholder: 'ป้อนชื่อรายงานเปรียบเทียบ',
      norm: 'เกณฑ์มาตรฐาน:',
      normPlaceholder: 'เลือกเกณฑ์มาตรฐาน',
      normTip: 'เลือกเกณฑ์มาตรฐานที่ใช้สำหรับการเปรียบเทียบโปรเจกต์',
      selectProject: 'เลือกโปรเจกต์',
      searchPlaceholder: 'ค้นหาตามชื่อโปรเจกต์/โฆษณา/แบรนด์',
      selectedCountPrefix: ' เลือกแล้ว ',
      selectedCountSuffix: ' โปรเจกต์ สูงสุด {{max}} โปรเจกต์',
      startCompare: 'เริ่มเปรียบเทียบ',
      save: 'บันทึก',
      cancel: 'ยกเลิก',
      maxSelectedWarning: 'คุณเลือกได้สูงสุด 10 โปรเจกต์',
      reportNameRequired: 'ป้อนชื่อรายงานเปรียบเทียบ',
      normRequired: 'เลือกเกณฑ์มาตรฐาน',
      projectRequired: 'เลือกโปรเจกต์',
    },
    dataComparisonInfoPage: {
      defaultReportName: 'ชื่อรายงานเปรียบเทียบ',
      reportNotFound: 'ไม่พบรายงาน',
      back: 'ย้อนกลับ',
      modify: 'แก้ไข',
      deletedProjectTip: 'โปรเจกต์ต่อไปนี้: {{names}} ถูกลบแล้ว หลังจากยืนยัน รายงานเปรียบเทียบจะได้รับการอัปเดตและโปรเจกต์ที่ถูกลบจะถูกนำออก',
      confirmDeletedProjects: 'ยืนยัน',
      metricScore: 'คะแนนตัวชี้วัด',
      tabDimension: 'ห้ามิติ',
      tabMoment: 'ช่วงเวลาสำคัญ',
      tabAttitude: 'ทัศนคติผู้บริโภค',
      adeffScore: 'คะแนน AdEff',
      brandName: 'ชื่อแบรนด์',
      projectName: 'ชื่อโปรเจกต์',
      industry: 'อุตสาหกรรม',
      targetMarket: 'ตลาดเป้าหมาย',
      gender: 'เพศ TA',
      age: 'อายุ TA',
      adProject: 'โปรเจกต์โฆษณา',
      normLabel: 'เกณฑ์มาตรฐาน',
      mixedCreativeBenchmarkTip: 'ไม่มีเกณฑ์มาตรฐานเมื่อเปรียบเทียบครีเอทีฟทั่วไปและครีเอทีฟสแปลชพร้อมกัน',
      emptyProject: 'เลือกโปรเจกต์เพื่อดูข้อมูลเปรียบเทียบ',
      viewProjectDetail: 'ดูรายละเอียดโปรเจกต์',
      listSeparator: ', ',
      metricLabels: {
        attention: 'พลังความสนใจ',
        infectivity: 'พลังอารมณ์',
        delivery: 'พลังข้อความ',
        brand: 'พลังแบรนด์',
        persuasion: 'พลังโน้มน้าว',
        gazeRecognition: 'การจดจำสายตา',
        emotionRecognition: 'การจดจำอารมณ์',
        engagementRecognition: 'การจดจำการมีส่วนร่วม',
        goldenSeconds: 'สามวินาทีทอง',
        brandMoment: 'ช่วงเวลาของแบรนด์',
        productMoment: 'ช่วงเวลาที่กระตุ้นความสนใจ',
        messageMoment: 'ช่วงเวลาข้อมูล',
        endingSeconds: 'สามวินาทีสุดท้าย',
        likeability: 'ความชอบ',
        newInformation: 'ข้อมูลใหม่',
        messageRelevance: 'ความเกี่ยวข้องของข้อความ',
        comprehension: 'ความเข้าใจ',
        credibility: 'ความน่าเชื่อถือ',
        brandLinkage: 'การเชื่อมโยงแบรนด์',
        uniqueness: 'ความเป็นเอกลักษณ์',
        learnMoreIntent: 'ความตั้งใจที่จะเรียนรู้เพิ่มเติม',
        purchaseIntent: 'ความตั้งใจซื้อ',
        recommendIntent: 'ความน่าแชร์',
        brandLikeabilityLift: 'การเพิ่มขึ้นของความชอบแบรนด์',
        purchaseIntentionLift: 'การเพิ่มขึ้นของความตั้งใจซื้อ',
        attentionIndex: 'ดัชนีความสนใจ',
        emotionIndex: 'ดัชนีอารมณ์',
        cognitionIndex: 'ดัชนีการรับรู้',
      },
    },
    experience: {
      projectDetailPage: {
        analysisCompleted: 'โปรเจกต์ประเมินครีเอทีฟ TVC ของคุณเสร็จสมบูรณ์แล้ว',
        title: {
          text1: 'การทดสอบครีเอทีฟโฆษณา',
          text2: 'รายงานการทดสอบ',
        },
        flowAnalysis: {
          desc1: 'AdEff กำลังแยกองค์ประกอบวิดีโอโฆษณาของคุณ',
          desc2: 'แยกองค์ประกอบวิดีโอเสร็จสิ้น',
          desc3: 'กำลังวิเคราะห์ความสนใจทางสายตาของผู้บริโภค',
          desc4: 'กำลังวิเคราะห์จุดโฟกัสทางสายตาตามโปรไฟล์ผู้บริโภค',
          desc5: 'กำลังสร้างแผนที่ความร้อนของความสนใจ',
          desc6: 'สร้างแผนที่ความร้อนแบบไดนามิกแล้ว',
          desc7: 'กำลังวัดการตอบสนองทางการรับรู้และประสาท',
          desc8: 'กำลังติดตามสายตา อารมณ์ และการมีส่วนร่วมแบบวินาทีต่อวินาที',
          desc9: 'กำลังสร้างเส้นโค้งการตอบสนองทางประสาท',
          desc10: 'สร้างเส้นโค้งการตอบสนองทางประสาทแล้ว',
          desc11: 'กำลังวิเคราะห์ประสิทธิภาพในช่วงเวลาสำคัญ',
          desc12: 'กำลังวัดการตอบสนองทางการรับรู้และประสาทในช่วง: 3 วินาทีทอง ช่วงข้อความ ช่วงแบรนด์ จุดสูงสุดของความสนใจ และ 3 วินาทีสุดท้าย',
          desc13: 'กำลังสังเคราะห์ตัวชี้วัดช่วงเวลาสำคัญ',
          desc14: 'วิเคราะห์ช่วงเวลาสำคัญเสร็จสิ้น',
          desc15: 'กำลังวิเคราะห์ทัศนคติของผู้บริโภค',
          desc16: 'กำลังวิเคราะห์ทัศนคติต่อแบรนด์ ผลิตภัณฑ์ และเนื้อหา',
          desc17: 'กำลังสังเคราะห์ตัวชี้วัดทัศนคติ',
          desc18: 'ตัวชี้วัดทัศนคติเสร็จสิ้น',
          desc19: 'กำลังสร้างคะแนนแรงขับเคลื่อนทั้งห้า',
          desc20: 'คะแนนแรงขับเคลื่อนทั้งห้าพร้อมแล้ว',
          desc21: 'วิเคราะห์เสร็จสิ้น! รายงานประสิทธิภาพโฆษณาของคุณพร้อมแล้ว',
          terminology: {
            thumbExpand: 'ขยายภาพขนาดย่อ',
            thumbCollapse: 'ย่อภาพขนาดย่อ',
            gazeRecognition: 'การจดจำสายตา',
            gazeRecognitionDesc: 'วัดความเข้มข้นของความสนใจทางสายตา และบ่งชี้ว่าองค์ประกอบโฆษณาดึงดูดโฟกัสของผู้ชมได้มีประสิทธิภาพเพียงใด',
            emotionRecognition: 'การจดจำอารมณ์',
            emotionRecognitionDesc: 'วัดปริมาณอารมณ์เชิงบวกและการตอบสนองทางอารมณ์ทันทีที่เกิดจากโฆษณา',
            engagementRecognition: 'การจดจำการมีส่วนร่วม',
            engagementRecognitionDesc: 'วัดระดับการจดจ่อและการมีส่วนร่วม สะท้อนการลงทุนทางความคิดในเนื้อหาโฆษณา',
            theGolden3Seconds: 'ประสิทธิภาพ 3 วินาทีทอง',
            theGolden3SecondsDesc: 'ประเมินประสิทธิภาพของเนื้อหาโฆษณาใน 3 วินาทีแรก',
            keyMessage: 'ประสิทธิภาพข้อความหลัก',
            keyMessageDesc: 'วัดความสามารถของช่วงข้อมูลโฆษณาในการดึงดูดความสนใจและกระตุ้นความสนใจ',
            brand: 'ประสิทธิภาพแบรนด์',
            brandDesc: 'ประเมินการดึงดูดความสนใจเฉพาะแบรนด์และประสิทธิภาพการมีส่วนร่วม',
            interest: 'จุดสูงสุดของความสนใจ',
            interestDesc: 'ระบุช่วงเนื้อหาที่กระตุ้นความสะท้อนทางอารมณ์และการมีส่วนร่วมสูง',
            ending3Seconds: 'ประสิทธิภาพ 3 วินาทีสุดท้าย',
            ending3SecondsDesc: 'ประเมินประสิทธิภาพของเนื้อหาโฆษณาใน 3 วินาทีสุดท้าย',
            score: 'คะแนน',
            benchmark: 'เกณฑ์มาตรฐาน',
            metrics: 'ตัวชี้วัด',
            attitudePart: {
              attitudeMetrics: 'ตัวชี้วัดทัศนคติ',
              liking: 'ความชอบ',
              likingDesc: 'วัดทัศนคติเชิงอัตวิสัยและระดับความชอบโดยรวมของผู้ชมต่อโฆษณา',
              newInformation: 'ข้อมูลใหม่',
              newInformationDesc: 'วัดว่าผู้ชมรู้สึกว่าได้รับข้อมูลที่มีคุณค่าเกี่ยวกับแบรนด์หรือผลิตภัณฑ์ซึ่งไม่เคยทราบมาก่อนจากโฆษณาหรือไม่',
              messageRelevance: 'ความเกี่ยวข้องของข้อความ',
              messageRelevanceDesc: 'วัดระดับที่ผู้ชมรับรู้ว่าข้อมูลในโฆษณาเกี่ยวข้องโดยตรงกับตนเอง',
              comprehension: 'ความเข้าใจ',
              comprehensionDesc: 'วัดว่าข้อความหลักของโฆษณาถูกเข้าใจอย่างชัดเจน ถูกต้อง และไม่ต้องใช้ความพยายามหรือไม่',
              credibility: 'ความน่าเชื่อถือ',
              credibilityDesc: 'วัดระดับที่ผู้ชมเชื่อว่าข้อมูลที่โฆษณาสื่อสารนั้นเป็นจริง น่าเชื่อถือ และไว้วางใจได้',
              brandLinkage: 'การเชื่อมโยงแบรนด์',
              brandLinkageDesc: 'วัดความสามารถของผู้ชมในการเชื่อมโยงโฆษณากับแบรนด์เฉพาะได้อย่างถูกต้องและชัดเจน',
              uniqueness: 'ความเป็นเอกลักษณ์',
              uniquenessDesc: 'วัดว่าโฆษณาสร้างการรับรู้ที่ชัดเจนว่าแบรนด์มีเอกลักษณ์โดดเด่นและมีคุณค่าเมื่อเทียบกับคู่แข่งหรือไม่',
              willing: 'ความตั้งใจที่จะเรียนรู้เพิ่มเติม',
              willingDesc: 'วัดความเป็นไปได้เชิงอัตวิสัยที่ผู้ชมจะดำเนินการเชิงรุกเพื่อเรียนรู้เพิ่มเติมเกี่ยวกับแบรนด์หรือผลิตภัณฑ์หลังดูโฆษณา',
              purchase: 'ความตั้งใจซื้อ',
              purchaseDesc: 'วัดความเป็นไปได้เชิงอัตวิสัยที่ผู้ชมจะพิจารณาเลือกหรือซื้อผลิตภัณฑ์ของแบรนด์ในอนาคต',
              share: 'ความน่าแชร์',
              shareDesc: 'วัดความเป็นไปได้เชิงอัตวิสัยที่ผู้ชมจะแชร์โฆษณาหรือข้อมูลแบรนด์กับผู้อื่นอย่างกระตือรือร้น',
              brandLikeLift: 'การเพิ่มขึ้นของความชอบแบรนด์',
              brandLikeLiftDesc: 'วัดทิศทางและระดับการเปลี่ยนแปลงของความชอบโดยรวมต่อแบรนด์หรือผลิตภัณฑ์หลังเห็นโฆษณา',
              purchaseIntentLift: 'การเพิ่มขึ้นของความตั้งใจซื้อ',
              purchaseIntentLiftDesc: 'วัดทิศทางและระดับการเปลี่ยนแปลงของความตั้งใจพิจารณาซื้อผลิตภัณฑ์ของแบรนด์หลังเห็นโฆษณา',
            },
            dimensionPart: {
              forceDrives: 'แรงขับเคลื่อน',
              attension: 'ความสนใจ',
              emotionalImpact: 'ผลกระทบทางอารมณ์',
              messageClarity: 'ความชัดเจนของข้อความ',
              brandPower: 'พลังแบรนด์',
              persuasion: 'การโน้มน้าว',
              attentionForce: 'พลังความสนใจ',
              attentionForceDesc: 'วัดความสามารถของโฆษณาในการดึงดูดและรักษาความสนใจทางสายตาและการได้ยินของผู้ชม',
              emotionalForce: 'พลังอารมณ์',
              emotionalForceDesc: 'วัดความเข้มข้นของการสะท้อนทางอารมณ์ทันทีและโดยสัญชาตญาณ รวมถึงความผันผวนทางอารมณ์ที่เกิดจากเนื้อหาโฆษณา',
              messageForce: 'พลังข้อความ',
              messageForceDesc: 'วัดประสิทธิภาพที่ข้อความหลักของโฆษณาถูกระบุ เข้าใจ และจดจำอย่างชัดเจนโดยกลุ่มเป้าหมาย',
              brandForce: 'พลังแบรนด์',
              brandForceDesc: 'วัดประสิทธิภาพของโฆษณาในการเสริมอัตลักษณ์แบรนด์ เพิ่มความชอบต่อแบรนด์ และสร้างความเชื่อมโยงแบรนด์ที่แข็งแรง',
              persuasiveForce: 'พลังโน้มน้าว',
              persuasiveForceDesc: 'วัดพลังขั้นสุดท้ายของโฆษณาในการเปลี่ยนการรับรู้และขับเคลื่อนเจตนาพฤติกรรม',
            },
            result: {
              results: 'ผลลัพธ์',
              pass: 'ผ่าน',
              notPass: 'ไม่ผ่าน',
              adeffScore: 'คะแนน AdEff',
              adeffScoreDesc: 'คะแนน AdEff ถูกออกแบบมาเพื่อวัดประสิทธิภาพโดยรวมของโฆษณา',
              benchmarkDesc: 'คะแนน AdEff เฉลี่ยของโฆษณาทั้งหมดที่อัปโหลดในประเทศหรือภูมิภาคของโฆษณานั้น ใช้เป็นเกณฑ์เปรียบเทียบประสิทธิภาพ',
            },
          },
        },
        pptAnalysis: {
          emptyState: {
            waiting: 'กำลังรอ...',
            description: 'กำลังสร้างรายงานการทดสอบให้คุณ...',
          },
          generating: 'กำลังสร้าง...',
          freeTrialLockText1:
            'ในโหมดทดลองใช้ จะไม่สามารถดูตัวอย่างหรือดาวน์โหลดรายงานฉบับเต็มได้',
          freeTrialLockText2: 'สมัครใช้งานเพื่อปลดล็อก',
        },
      },
    },
  },
  professor: {
    account: 'บัญชี',
    password: 'รหัสผ่าน',
    login: 'เข้าสู่ระบบ',
    expertReviews: 'รีวิวผู้เชี่ยวชาญ',
    adVideoScore: 'ดัชนีประสิทธิภาพโฆษณา',
    subjectiveResponseCurve: 'เส้นโค้งการตอบสนองอัตนัย',
    indexAnalysis: 'การวิเคราะห์ดัชนี',
    keyResult: 'ผลลัพธ์หลัก',
    theGolden3Seconds: 'สามวินาทีทอง',
    informationTransmission: 'ช่วงเวลาข้อมูล',
    brandRelevance: 'ช่วงเวลาของแบรนด์',
    interestStimulation: 'ช่วงเวลาที่กระตุ้นความสนใจ',
    theEnding3Seconds: 'สามวินาทีสุดท้าย',
    heatMap: 'แผนที่ความร้อน',
    suggestion: 'ข้อเสนอแนะ',
    suggestion1: 'ข้อเสนอแนะ',
    submit: 'ส่ง',
    next: 'ถัดไป',
    summary: 'สรุป',
    advantages: 'ข้อดี',
    disadvantages: 'ข้อเสีย',
    option1: 'คาดเดา',
    option2: 'คาดเดาไม่ได้',
    resultJudgment: 'การตัดสินใจผล',
    placeholder: 'กรุณากรอกข้อเสนอแนะ',
    waitRateCount: 'จำนวนโฆษณาที่ต้องประเมิน',
    unfinishedTitle: 'คำเตือน',
    unfinishedRate:
      'โปรเจกต์ปัจจุบันมีเนื้อหาที่ยังไม่ได้ประเมิน คุณแน่ใจที่จะออกจากการประเมินหรือไม่?',
    unfinishedConfirm: 'ดำเนินการต่อ',
    unfinishedCancel: 'ออก',
    message: {
      submitSuccess: 'ขอบคุณคุณสำหรับการประเมิน',
      submitSuccess1: 'คุณได้ทำการประเมินโปรเจกต์นี้แล้ว ขอบคุณคุณสำหรับการประเมิน',
      loginSuccess: 'เข้าสู่ระบบสำเร็จ',
      rateUnfinished: 'คุณยังไม่ได้ประเมินเนื้อหาปัจจุบัน กรุณากรอกก่อนเข้าสู่คำถามถัดไป',
      rateLocation: 'คุณถูกนำไปที่เนื้อหาที่ยังไม่ได้ประเมิน',
    },
  },
  modals: {
    freeTrialModal: {
      title: 'ขอทดลอง',
      title1: 'ทดลองฟรี',
      trial: 'ทดลอง',
      hiddenBoxText1: 'ค้นพบหลายข้อดี ข้อเสีย และข้อเสนอแนะ',
      hiddenBoxText2: 'สมัครใช้งานเพื่อรับรายงานที่สมบูรณ์',
      hiddenBoxBtn: 'สมัครใช้งาน',
      applyBox: {
        name: 'ชื่อผู้ใช้',
        tel: 'หมายเลขติดต่อ',
        department: 'หน่วยงาน',
        role: 'สิทธิ์',
        country: 'ประเทศ',
        city: 'เมือง',
        pleaseEnter: 'กรุณากรอก',
        pleaseSelect: 'กรุณาระบุ',
        pleaseEnterTheName: 'กรุณากรอกชื่อผู้ใช้',
        pleaseEnterTheTel: 'กรุณากรอกหมายเลขติดต่อ',
        pleaseEnterValidTel: 'กรุณากรอกหมายเลขติดต่อที่ถูกต้อง',
        pleaseEnterValidEmail: 'กรุณากรอกอีเมลที่ถูกต้อง',
        pleaseSelectTheDepartment: 'กรุณาระบุหน่วยงาน',
        pleaseSelectTheRole: 'กรุณาระบุสิทธิ์',
        pleaseSelectTheCountry: 'กรุณาระบุประเทศ',
        pleaseEnterTheCity: 'กรุณากรอกเมือง',
        textIsRequired: 'กรุณากรอก',
        submit: 'ส่ง',
        tip: 'แต่ละบริษัทมีโอกาสทดลองใช้งานฟรีเพียงครั้งเดียว',
      },
      gotTrial: 'คุณได้รับการทดลอง!',
      goPc: 'กรุณากรอกข้อมูลในหน้าที่สำหรับการทดลอง',
      back: 'กลับ',
      country: {
        China: 'จีน',
        Japan: 'ญี่ปุ่น',
        Korea: 'เกาหลี',
        Indonesia: 'อินโดนีเซีย',
        Thailand: 'ไทย',
        Singapore: 'สิงคโปร์',
        Malaysia: 'มาเลเซีย',
        Vietnam: 'เวียดนาม',
        Germany: 'เยอรมนี',
        Britain: 'สหราชอาณาจักร',
        France: 'ฝรั่งเศส',
        Italy: 'อิตาลี',
        Russia: 'รัสเซีย',
        Spain: 'สเปน',
        Turkey: 'ตุรกี',
        America: 'สหรัฐอเมริกา',
        Canada: 'แคนาดา',
        Brazil: 'บราซิล',
        Other: 'อื่นๆ',
      },
      department: {
        Brand: 'บริษัท',
        Market: 'ตลาด',
        Marketing: 'การตลาด',
        IT: 'IT',
        Procurement: 'การซื้อขาย',
        Other: 'อื่นๆ',
      },
      role: {
        President: 'ผู้บริหารระดับสูง',
        CMO: 'CMO หรือผู้บริหารระดับอื่นๆ',
        Director: 'ผู้บริหารระดับกลาง',
        Manager: 'ผู้บริหารระดับต่ำ',
        Other: 'อื่นๆ',
      },
      message: {
        submitSuccess: 'ขอบคุณคุณสำหรับการประเมิน',
        submitFailed: 'ขอบคุณคุณสำหรับการประเมิน',
      },
    },
    downloadPptRechargeModal: {
      title: 'รายงานไม่สามารดาวน์โหลดได้',
      desc1: 'ในรุ่นทดลองไม่สามารถดาวน์โหลดรายงานได้',
      desc2: 'สมัครใช้งานเพื่อรับรายงานที่สมบูรณ์',
      btn: 'สมัครใช้งาน',
    },
    checkInvitationCodeModal: {
      invitationCode: 'รหัสอ้างอิง',
      invitationCodeDesc1: 'รหัสอ้างอิงไม่สามารถเปลี่ยนแปลงได้ กรุณาติดต่อเราเพื่อเปลี่ยนแปลง',
      invitationCodeDesc2: 'หากคุณใช้งานผ่านการอ้างอิงจากตัวแทน กรุณากรอกรหัสอ้างอิง',
      invitationCodePlaceholder: 'กรุณากรอกรหัสอ้างอิง',
      invitationCodeError: 'รหัสอ้างอิงไม่ถูกต้อง',
      invitationCodeSuccess: 'รหัสอ้างอิงได้ถูกเปลี่ยนแปลงสำเร็จ',
      ok: 'ตกลง',
      cancel: 'ยกเลิก',
    },
    aigcPromotionModal: {
      title: 'สิทธิประโยชน์สำหรับครีเอเตอร์ AIGC',
      subTitle: 'สมัครตอนนี้เพื่อรับโอกาสประเมินวิดีโอด้วย AI <tmp>5</tmp> ครั้ง',
      desc1: 'เข้าร่วมกิจกรรม AdEff AI Creative Testing เพื่อประเมินครีเอทีฟของคุณ',
      desc2: 'สมัครตอนนี้และรับสิทธิ์ทดสอบฟรี 5 ครั้งทันที',
      registerBtn: 'สมัครเพื่อรับโอกาสทดสอบ',
      tip: 'สำหรับผู้ใช้ใหม่ที่สมัครผ่านทางเข้าแคมเปญครีเอเตอร์ AIGC เท่านั้น',
      floatTitle: 'ทดสอบฟรี',
    },
  },
}

export default TRANSLATION
